import { Link } from 'react-router-dom'
import tw from 'tailwind-styled-components'

export const ContainerLogo = tw.div`
mt-16 
w-[289px] 
h-[74px] 
`
const Container = tw.div`
flex
h-screen
`
const WrapperRight = tw.div`
flex
items-center
justify-center
bg-blueTheme
w-full
px-2
`
const WrapperLeft = tw.div`
w-[549px]
hidden
md:flex
`
const SubWrapperLeft = tw.div`
flex
items-center
justify-center
h-full
lg:w-[549px]
max-w-[549px]
bg-white
`
const BodyRightSide = tw.section`
px-10
bg-white
lg:w-[461px]
w-[312px]
h-[404px]
rounded-lg
md:mb-28
mb-[33px]
`
const Section = tw.section`
w-full 
flex 
flex-col 
items-center
`
const FooterRightSide = tw.footer`


`
const OneProduct = tw.span`
text-white
text-sm
font-normal
`
const MainLeft = tw.main`
flex
flex-col
items-center
text-center
w-[376px]
`
const MainRight = tw.main`
flex
flex-col
items-center
text-center
w-full
`
const MainTitle = tw.span`
text-2xl
font-semibold
text-darkBlue
mt-9
mb-1
tracking-wider
`
const SubTitle = tw.span`
text-2xl
font-semibold
text-yellow
mb-8
tracking-wider
`
const MainText = tw.span`
text-sm
font-normal
text-darkBlue
h-[105px]
w-[367px]
`
const AccessImg = tw.img`

`
const ButtonNotify = tw.button`
bg-blueTheme
border-blue
p-2
lg:w-[368px]
w-[264px]
h-[45px]
rounded-lg
hover:brightness-90
transition-all
active:scale-[.98]
mb-[61px]
font-semibold
text-white
`
const TextAccount = tw.span`
text-darkBlue
text-base
font-medium
`
const TextLogin = tw(Link)`
font-semibold
text-blueTheme
underline
hover:brightness-75
transition-all
`

const TextLoginHere = tw.span`
font-semibold
text-blue
color: #005EB8
hover:brightness-75
transition-all
underline
`

const Line = tw.div`
w-px
h-[37px]
bg-white
`
const ImgFooter = tw.img`
`
const ImgNotify = tw.img`
mt-16 
w-[289px] 
h-[74px] 
`

export {
    Container,
    WrapperRight,
    BodyRightSide,
    FooterRightSide,
    MainLeft,
    MainRight,
    MainTitle,
    SubTitle,
    MainText,
    AccessImg,
    Section,
    ButtonNotify,
    TextLogin,
    TextLoginHere,
    TextAccount,
    Line,
    ImgFooter,
    WrapperLeft,
    SubWrapperLeft,
    ImgNotify,
    OneProduct,
}
